import React from 'react';
import './style.scss';
import { useHistory } from 'react-router-dom';
import etownLogo from './etown-logo.png';
import etownCentralLogo from './etown-central-logo.png';

const MapMarkers = ({ handleElementClick }) => {
  const history = useHistory();

  // Coordinates based on 2708x1560 resolution
  // Converted from previous 1716x1287 relative positions
  const MARKERS = [
    {
      id: 'etown-central',
      x: 2110,
      y: 1020,
      width: 219,
      height: 84,
      href: etownCentralLogo,
      className: 'map-markers__gray',
      onClick: () => history.push('/etown-central'),
    },
    {
      id: 'etown-6',
      x: 1373,
      y: 509,
      width: 192,
      height: 84,
      href: etownLogo,
      className: 'map-markers__red',
      onClick: (e) => handleElementClick('red', e),
    },
  ];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2708 1560"
      fill="none"
      className="map-svg"
      preserveAspectRatio="none"
      style={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        pointerEvents: 'none',
        display: 'block',
      }}
    >
      {MARKERS.map((marker) => (
        <g
          key={marker.id}
          className={marker.className}
          onClick={marker.onClick}
          style={{ pointerEvents: 'auto', cursor: 'pointer' }}
        >
          <image
            className="map-marker-image"
            x={marker.x}
            y={marker.y}
            width={marker.width}
            height={marker.height}
            href={marker.href}
          />
        </g>
      ))}
    </svg>
  );
};

export default MapMarkers;
